import React from 'react';
import SettingsProfilePage from './SettingsProfilePage';

export default function SettingsPage() {
  return <SettingsProfilePage />;
}
